import React, { useEffect } from "react";
import "./logo.css";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";

function Logo({ openfrom }) {
  const selectedTheme = localStorage.getItem("selectedTheme");
  const logoSrc =
    selectedTheme === "dark"
      ? toAbsoluteUrl("/image/es3a.png")
      : toAbsoluteUrl("/image/es3b.png");
  return (
    <div className="d-flex align-items-center justify-content-center">
      <a href="/" className="logo d-flex align-items-center">
        {openfrom === "login" ? (
          <img
            src={logoSrc}
            alt="Logo"
            style={{ width: "25vh", height: "10vh" }}
          />
        ) : (
          <img src={logoSrc} alt="Logo" style={{ maxHeight: "26px" }} />
        )}
      </a>
    </div>
  );
}

export default Logo;
